<template>
  <v-container>
    <template>
      <v-layout row-wrap>
        <p class="title error--text">
          Total Amount: {{ $store.state.currencySymbol }}
        </p>
        <p class="title error--text">
          {{ calculateTotalAmount }}
        </p>
        <v-badge color="success" right>
          <template v-slot:badge>
            <v-icon dark>
              mdi-check
            </v-icon>
          </template>
        </v-badge>
      </v-layout>

      <v-stepper v-model="step" vertical>
        <v-stepper-header>
          <v-stepper-step class="twhite--text" step="1" :complete="step > 1"
            >Technology
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step class="twhite--text" step="2" :complete="step > 2"
            >Configuration</v-stepper-step
          >
          <v-divider></v-divider>
          <v-stepper-step class="twhite--text" step="3"
            >Place Order</v-stepper-step
          >
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content step="1">
            <v-alert class="white--text" :type="step1Type">{{ step1 }}</v-alert>
            <v-text-field
              label="Enter your Project Name"
              v-model="projectName"
              required
            ></v-text-field>

            <v-text-field
              label="Service Name"
              v-model="name"
              readonly
              required
            ></v-text-field>
            <v-text-field
              label="Service Type"
              v-model="serviceType"
              readonly
              required
            ></v-text-field>
            <v-text-field
              label="Order Category"
              v-model="tags"
              readonly
              required
            ></v-text-field>

            <v-btn rounded color="primary" @click.native="validateStep1"
              >Continue</v-btn
            >
          </v-stepper-content>
          <v-stepper-content step="2">
            <v-alert class="white--text" :type="step3Type">{{ step3 }}</v-alert>
            <v-switch
              v-model="hasDomain"
              :label="`Do you have a domain?`"
            ></v-switch>
            <template v-if="hasDomain">
              <v-text-field
                v-model="domainName"
                label="Domain Name"
                required
              ></v-text-field>
              <v-select
                v-model="dnsName"
                :items="hosts"
                menu-props="auto"
                hide-details
                label="Domain Registrator"
                single-line
              ></v-select>
            </template>
            <v-flex ma-4>
              <v-btn rounded text @click.native="step = 1">Previous</v-btn>
              <v-btn rounded color="primary" @click.native="validateStep2"
                >Continue</v-btn
              >
            </v-flex>
          </v-stepper-content>
          <v-stepper-content step="3">
            <v-textarea
              v-model="comments"
              label="Leave your comments or instructions"
              required
            ></v-textarea>

            <v-flex ma-4>
              <v-btn text @click.native="step = 2">Previous</v-btn>
              <v-dialog rounded v-model="dialog" persistent max-width="425">
                <template v-slot:activator="{ on }">
                  <v-btn rounded pa-2 color="primary" v-on="on">Order</v-btn>
                </template>
                <v-card>
                  <v-img
                    :src="require('@/assets/logo.png')"
                    height="100"
                    width="200"
                    contain
                  >
                  </v-img>
                  <v-progress-linear
                    indeterminate
                    color="primary"
                    :active="activeBar"
                  ></v-progress-linear>
                  <v-divider></v-divider>
                  <v-card-title>{{ cardTitle }} </v-card-title>
                  <v-card-text>
                    <v-flex v-if="beforePay">
                      <h4>
                        Total Amount Payable: {{ $store.state.currencySymbol }}
                        {{ calculateTotalAmount }}
                      </h4>
                    </v-flex>
                    <v-flex v-else>
                      <h4>{{ payMessage }}</h4>
                    </v-flex>
                  </v-card-text>
                  <v-card-actions>
                    <v-flex>
                      <v-btn
                        rounded
                        color="primary"
                        :disabled="clicked"
                        v-on:click="submit"
                        >Pay</v-btn
                      >
                      <v-btn rounded color="accent" v-on:click="setValues"
                        >Close</v-btn
                      >
                    </v-flex>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-flex>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </template>
  </v-container>
</template>

<script>
import { functions } from "@/Firebase";
export default {
  name: "ServiceForm",
  data: () => ({
    beforePay: true,
    dialog: false,
    step: 1,
    clicked: false,
    cardTitle: "Thanks for trusting us",
    payMsg: "Please wait,your payment is being processed",
    serviceType: "",
    serviceName: "",
    orderType: "",
    projectName: "",
    subscriptionType: 3,
    step1: "Please enter a project name for your project",
    step1Type: "primary",
    step3: "If you have purchased domain name(websitename),please enter it",
    step3Type: "primary",
    hostingConfig: "",
    hostingLocation: "Mumbai",
    premiumHostingLocation: [],
    premiumHosting: [],
    noParam: false,
    hasDomain: true,
    domainName: "",
    dnsName: "",
    productId: "",
    typeId: 6,
    comments: "",
    status: "paid",
    totalAmount: 0,
    hosts: ["GoDaddy", "BlueHost", "NameCheap", "HostGator", "Others"],
    orderId: ""
  }),
  props: {
    web: {
      type: Object
    }
  },
  mounted() {
    if (this.web == null) {
      window.location.href = "/explore-services";
    } else {
      this.tags = this.web.tags;
      this.serviceType = this.web.serviceType;
      this.productId = this.web.id;
      this.name = this.web.name;
      this.subscriptionType = this.web.subscriptionType;
      if (this.web.id == 3004 || this.web.id == 3005) {
        this.typeId = 7;
        if (this.$store.state.currency == "INR")
          this.totalAmount = this.web.INR;
        else this.totalAmount = this.web.USD;
      }
    }
  },

  computed: {
    getPremiumHostingConfig() {
      return this.premiumHosting;
    },
    checkParam() {
      return this.noParam;
    },
    calculateTotalAmount() {
      return this.totalAmount;
    },
    payMessage() {
      return this.payMsg;
    }
  },
  methods: {
    setValues() {
      this.clicked = false;
      this.beforePay = true;
      this.activeBar = false;
      this.dialog = false;
    },
    getIndex() {
      let hostPrice = this.web[this.hostingLocation];
      for (var i = 0; i < hostPrice.length; i++) {
        if (hostPrice[i].config == this.hostingConfig) {
          this.selectedIndex = i;
          break;
        }
      }
      let tempPrice = hostPrice[this.selectedIndex];
      this.totalAmount = tempPrice[this.$store.state.currency];
    },
    changePremiumHosting() {
      this.premiumHosting = this.web[this.hostingLocation];
      if (this.premiumHosting.length > this.selectedIndex) {
        let tempPrice = this.premiumHosting[this.selectedIndex];
        this.totalAmount = tempPrice[this.$store.state.currency];
      } else this.totalAmount = 0;
    },
    validateStep1() {
      if (this.projectName == "") {
        this.step1 = "Please enter the project name";
        this.step1Type = "accent";
        return (this.step = 1);
      } else {
        this.step1 = "";
        this.step1Type = "";
        return (this.step = 2);
      }
    },
    validateStep2() {
      if (this.hasDomain == true) {
        if (this.domainName == "" || this.dnsName == "") {
          this.step3Type = "accent";
          this.step3 = "Please fill your domain details properly";
          return (this.step = 2);
        } else {
          return (this.step = 3);
        }
      } else {
        return (this.step = 3);
      }
    },

    submit() {
      var vm = this;
      this.clicked = true;
      this.beforePay = false;
      this.payMsg = "Please wait,the payment gateway will open in few seconds";
      var getOrderId = functions.httpsCallable("getOrderId");
      getOrderId({
        currency: this.$store.getters.currency,
        amount: this.totalAmount * 100,
        uid: this.$store.getters.userId
      })
        .then(result => {
          this.payMsg = "Processing your payment";
          var userId = this.$store.state.userId;
          var today = new Date();
          var mon = today.getMonth() + 1;
          var expDate = "";
          var nextDate = today.getDate();
          if (this.subscriptionType == 1) {
            let year = today.getFullYear();
            mon = mon + 1;
            if (mon == 13) {
              mon = 1;
              year = year + 1;
            }
            expDate = year + "-" + mon + "-" + nextDate;
          } else if (this.subscriptionType == 2) {
            if (nextDate == 29 && mon == 2 && today.getFullYear() % 4 == 0)
              nextDate == 28;
            expDate = today.getFullYear() + 1 + "-" + mon + "-" + nextDate;
          } else {
            expDate = today.getFullYear() + 1 + "-" + mon + "-" + nextDate;
          }

          var oDate = today.getFullYear() + "-" + mon + "-" + today.getDate();
          oDate = String(oDate);
          expDate = String(expDate);
          var orderDetails = {
            displayName: this.$store.state.displayName,
            project_name: this.projectName,
            order_id: result.data.id,
            user_id: userId,
            total_amount: this.totalAmount * 100,
            currency: this.$store.getters.currency,
            comments: this.comments,
            status: "paid",
            service_name: this.name,
            serviceType: this.serviceType,
            service_id: this.productId,
            start_date: oDate,
            domain_name: this.domainName,
            type: "Services",
            dns_name: this.dnsName,
            type_id: this.typeId,
            user_type: 1,
            expiry_at: expDate,
            subscription_type: this.subscriptionType,
            payment_gateways: "razorpay"
          };

          var options = {
            key: "rzp_live_TNj6aTAUEyIxLR", // Enter the Key ID generated from the Dashboard
            name: this.web.Name,
            amount: this.totalAmount * 100,
            currency: this.$store.getters.currency,
            callback_url: "https://saascadetech.com",
            order_id: result.data.id,
            payment_capture: 1,
            description: this.name,
            image: "./assets/logo.png",
            //This is a sample Order ID. Create an Order using Orders API. (https://razorpay.com/docs/payment-gateway/orders/integration/#step-1-create-an-order). Refer the Checkout form table given below
            handler: function(response) {
              var insertOrderServices = functions.httpsCallable(
                "insertOrderServices"
              );
              insertOrderServices({
                orderDetails: orderDetails,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_order_id: response.razorpay_order_id
              }).then(res => {
                vm.payMsg = res.data.msg;
                vm.cardTitle = "Verifying payment ID, please wait";
                var verifySignature = functions.httpsCallable(
                  "verifySignature"
                );
                verifySignature({
                  razorpay_payment_id: response.razorpay_payment_id,
                  razorpay_order_id: response.razorpay_order_id,
                  razorpay_signature: response.razorpay_signature
                }).then(res => {
                  vm.cardTitle = res.data.msg;
                  vm.payMsg = "Completed";
                  vm.beforePay = true;
                  vm.dialog = false;
                  window.location.href = "/orders-services";
                });
              });
            },
            prefill: {
              name: this.$store.getters.displayName,
              email: this.$store.getters.email,
              contact: this.$store.getters.phNumber
            },
            notes: {
              user_id: this.$store.getters.userId,
              project_name: this.projectName,
              total_amount: this.totalAmount * 100,
              currency: this.$store.getters.currency,
              status: this.status,
              user_type: 1,
              service_id: this.productId,
              serviceType: this.serviceType,
              service_name: this.name,
              domain_name: this.domainName,
              dns_name: this.dnsName,
              subscription_type: this.subscriptionType
            },
            theme: {
              color: "#5856E8"
            }
          };
          var rzp1 = new window.Razorpay(options);
          rzp1.open();
        })
        .catch(error => {
          alert("Error " + error);
        });
    }
  }
};
</script>

<style></style>
